module.exports = __webpack_public_path__ + "img/p5renwu.21a45761.png";